import React, { Component } from "react";
import * as actions from "../../actions/meeting.action";
import { getAllLocations } from "../../actions/other_info/location.action";
import { connect } from "react-redux";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormInput,
  FormSelect
} from "shards-react";
import Moment from "react-moment";
import { Formik } from "formik";
import ContentPagination from "../Layout/Pagination";
import { Modal, Button, Spin, Empty } from 'antd';
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, DatePicker } from "material-ui-thai-datepickers";
import 'moment/locale/th';
import Autosuggest from "react-autosuggest";
import {
  LoadingOutlined,
  CloseOutlined
} from '@ant-design/icons';


class Meeting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meetings: [],
      locations: [],
      currentPage: 0,
      totalPages: 1,
      perPage: 10,
      loading: false,
      meetingName: '',
      meetingSequence: '',
      meetingLocation: '',
      meetingDate: null,
      meetingYear: null,
      meetingTime: null,
      suggestions: []
    };
  }

  async componentDidMount() {
    await this.props.getAllLocations();
    await this.getMeetings(0);
  }

  async getMeetings(page) {
    this.setState({ loading: true });

    await this.props.getMeetings({
      date: this.state.meetingDate,
      year: this.state.meetingYear,
      name:  this.state.meetingName,
      location: this.state.meetingLocation,
      sequence:  this.state.meetingSequence,
      page: page
    });

    const { meetings, total, isFetching } = this.props.meetingReducer;

    const totalPages = Math.ceil(total / this.state.perPage);

    if (!isFetching && meetings) {
      this.setState({
        meetings,
        totalPages,
        locations: this.props.locationsReducer.locations || [],
      });
    }

    this.setState({ loading: false });
  }

  btnEditMeeting(meeting) {
    return (
      <React.Fragment>
        <a
          type="button"
          className="btn btn-xs btn-secondary text-white mr-2"
          href={"/meeting/edit/" + meeting.id}
        >
          แก้ไข
        </a>

        <a
          onClick={() => {
            const _this = this

            Modal.confirm({
              title: <div>ยืนยันการลบเอกสาร <span className="font-weight-bold">{meeting.title}</span></div>,
              okText: 'ลบ',
              cancelText: 'ยกเลิก',
              maskClosable: true,
              onOk() {  
                _this.deleteMeeting(meeting.id)
              }
            });
          }}
          type="button"
          className="btn btn-xs btn-danger text-white"
        >
          ลบ
        </a>
      </React.Fragment>
    );
  }

  async deleteMeeting(id) {
    await this.props.deleteMeeting(id);
    this.getMeetings(this.state.currentPage);
  }

  renderTable = () => {
    return (
      <table className="table table-bordered mt-4 border">
        <thead>
          <tr>
            <th>หัวข้อการประชุม</th>
            <th className="text-center">ครั้งที่</th>
            <th className="text-center">วันที่</th>
            <th className="text-center" width={130}>เวลา</th>
            <th className="text-center" width={100}>แก้ไข/ลบ</th>
          </tr>
        </thead>
        <tbody>
          {this.state.meetings.map((meeting, index) => {
            return (
              <tr key={meeting.id}>
                <td className="text-left align-middle">{meeting.title}</td>
                <td className="text-center align-middle">
                  {meeting.sequence}/{meeting.year + 543}
                </td>
                <td className="text-center align-middle">
                  <Moment format="DD/MM/YYYY" add={{ years: 543 }}>{meeting.meetingStart}</Moment>
                </td>
                <td className="text-center align-middle">
                  <Moment format="HH:mm">{meeting.meetingStart}</Moment> -{" "}
                  <Moment format="HH:mm">{meeting.meetingEnd}</Moment>
                </td>
                <td className="text-center align-middle">
                  {this.btnEditMeeting(meeting)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  changePage(page) {
    this.setState({ currentPage: page });
    this.getMeetings(page);
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: this.state.meetings,
    });
  };

  onSuggestionSelected = (
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) => {
    this.setState({
      meetingName: suggestion.title
    });
  };

  getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    const result = this.state.meetings.filter((meeting) =>
      inputLength !== 0
        ? meeting.title.toLowerCase().includes(inputValue)
        : true
    );

    if (inputLength === 0) {
      this.setState({
        meetingName: ''
      });
    }

    return result;
  };

  renderSuggestion = (suggestion) => suggestion.title;

  shouldRenderSuggestions() {
    return true;
  }

  getSuggestionValue = (suggestion) => suggestion.title;

  onMeetingNameChange = (event, { newValue }) => {
    this.setState({
      meetingName: newValue,
    });
  };

  render() {
    const { meetingName, suggestions } = this.state;

    const inputProps = {
      placeholder: "พิมพ์ชื่อการประชุม",
      value: meetingName,
      onChange: this.onMeetingNameChange,
    };

    return (
      <Container fluid>
        <div style={{ padding: 20 }}>
          <Card className="mb-3">
            <CardBody>
              <div className="d-flex align-items-center mb-4">
                <h5 className="font-weight-bold flex-fill">เพิ่มการประชุม</h5>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => this.props.history.push(`/meeting/create`)}
                >
                  เพิ่มการประชุม
                </Button>
              </div>

              <Formik
                initialValues={{
                  start_date: "",
                  end_date: "",
                  category_name: "",
                }}
                onSubmit={async (values) => {
                  const value = {};

                  let startDate = null;
                  let endDate = null;

                  if (values.start_date) {
                    startDate = moment(values.start_date).format("YYYY-MM-DD");
                  }

                  if (values.end_date) {
                    endDate = moment(values.end_date).format("YYYY-MM-DD");
                  }

                  value.start = startDate;
                  value.end = endDate;

                  if (values.category_name) {
                    value.categoryName = values.category_name;
                  }

                  this.props.getReportBookRankPurchase(value);
                }}
              >
                {(props) => {
                  const {
                    values,
                    handleSubmit,
                    handleChange,
                  } = props;
                  return (
                    <form onSubmit={handleSubmit}>
                      <Row form>
                        <Col sm="4">
                          <div className="d-flex align-items-center mb-2">
                            ระบุปี <CloseOutlined className="ml-2" onClick={() => this.setState({meetingYear: null})}/>
                          </div>
                          
                          <MuiPickersUtilsProvider utils={MomentUtils} locale={'th'}>
                            <DatePicker
                              label=""
                              format="YYYY"
                              pickerHeaderFormat="YYYY"
                              value={this.state.meetingYear}
                              yearOffset={543}
                              views={["year"]}
                              className="d-flex"
                              okLabel="ตกลง"
                              autoOk={true}
                              cancelLabel="ยกเลิก"
                              clearable={true}
                              onChange={(value) => this.setState({meetingYear: value ? value.toDate() : null})}
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col sm="4">
                          <div className="d-flex align-items-center mb-2">
                            วันที่ประชุม <CloseOutlined className="ml-2" onClick={() => this.setState({meetingDate: null})} />
                          </div>
                          <MuiPickersUtilsProvider utils={MomentUtils} locale={'th'}>
                            <DatePicker
                              label=""
                              format="DD MMM YYYY"
                              value={this.state.meetingDate}
                              yearOffset={543}
                              className="d-flex"
                              autoOk={true}
                              onChange={(value) => this.setState({meetingDate: value ? value.toDate() : null})}
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col sm="4">
                          <div>
                            <label>ครั้งที่</label>
                            <FormInput
                              name="sequence"
                              id="sequence"
                              onChange={(e) => this.setState({sequence: e.target.value})}
                              value={this.state.sequence}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row form className="mt-3">
                        <Col md="6" className="form-group">
                          <label>ชื่อการประชุม</label>
                          <Autosuggest
                            suggestions={suggestions}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                            shouldRenderSuggestions={this.shouldRenderSuggestions}
                            onSuggestionSelected={this.onSuggestionSelected}
                            getSuggestionValue={this.getSuggestionValue}
                            renderSuggestion={this.renderSuggestion}
                            inputProps={inputProps}
                          />
                        </Col>
                        <Col md="6" className="form-group">
                          <label>สถานที่</label>
                          <FormSelect
                            name="location"
                            id="location"
                            onChange={(e) => this.setState({meetingLocation: e.target.value})}
                            value={this.state.meetingLocation}
                          >
                            <option value=""></option>
                            {this.state.locations.map((location) => {
                              return (
                                <option value={location.id} key={location.id}>
                                  {location.name}
                                </option>
                              );
                            })}
                          </FormSelect>
                        </Col>
                      </Row>

                      <div className="text-right">
                        <Button 
                          type="primary"
                          style={{width: 100}}
                          onClick={() => this.getMeetings(0)}
                        >
                          ค้นหา
                        </Button>
                      </div>
                    </form>
                  );
                }}
              </Formik>

              <Spin 
              spinning={this.state.loading}
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            >   
              { 
                this.state.meetings.length > 0 ?
                this.renderTable() :
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="ไม่พบข้อมูลการประชุม" className="mt-4"/>
              }
            </Spin>
            </CardBody>
            <CardBody className="pt-2">
              <nav className="text-right">
                {this.state.meetings.length > 0 && (
                  <ContentPagination
                    currentPage={this.state.currentPage}
                    totalPages={this.state.totalPages}
                    onPageChange={this.changePage.bind(this)}
                    pageShow={5}
                  />
                )}
              </nav>
            </CardBody>
          </Card>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({ 
  locationsReducer,
  meetingReducer 
}) => ({
  locationsReducer,
  meetingReducer,
});

const mapDispatchToProps = {
  ...actions,
  getAllLocations
};

export default connect(mapStateToProps, mapDispatchToProps)(Meeting);
